import {
  emailBlockSchema,
  type IEmailBlockSchema,
} from "@redotech/redo-model/email-template";
import {
  savedEmailSectionSchema,
  type ISavedEmailSection,
} from "@redotech/redo-model/saved-email-section";
import * as z from "zod/v4";

export const createSavedEmailSection = {
  name: "createSavedEmailSection" as const,
  input: z.object({
    name: z.string(),
    blocks: z.array(emailBlockSchema as IEmailBlockSchema),
  }),
  output: savedEmailSectionSchema as ISavedEmailSection,
};
